export function customSvgAnimation() {
    let svgContainer = $("[data-src-path]");
    let svgAnimInstance = [];
    let winTop = 0;
    let itemTop = 0;
    let $win = $(window);

    for (let i = 0; i < svgContainer.length; i++) {
        svgAnimInstance.push(
            lottie.loadAnimation({
                container: svgContainer[i],
                renderer: "svg",
                autoplay: false,
                loop: false,
                path: $(svgContainer[i]).attr("data-src-path")
            })
        );
    }

    $win.on("load scroll", function () {
        winTop = $win.scrollTop();

        svgAnimInstance.map( (item, index) => {
            itemTop = $(svgContainer[index]).offset().top;

            if (winTop + $win.innerHeight() > itemTop && winTop + $win.innerHeight() / 2 < itemTop + $win.innerHeight() + $win.innerHeight() / 2) {
                item.play();
            }
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/customSvgAnimation.js